import {
  Input as ChakraInput,
  InputGroup as ChakraInputGroup,
  InputGroupProps as ChakraInputGroupProps,
  InputLeftElement as ChakraInputLeftElement,
  InputRightElement as ChakraInputRightElement,
} from "@chakra-ui/react";

export function InputGroup({
  startElement,
  endElement,
  children,
  ...rest
}: {
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
} & ChakraInputGroupProps) {
  return (
    <ChakraInputGroup {...rest}>
      {startElement && <ChakraInputLeftElement>{startElement}</ChakraInputLeftElement>}
      {children}
      {endElement && <ChakraInputRightElement>{endElement}</ChakraInputRightElement>}
    </ChakraInputGroup>
  );
}

InputGroup.Field = ChakraInput;
